<template>
  <div :disabled="button_loading" id="page-loading">
    <!-- add/editfamzy charge form  -->
    <div class="vx-row mb-2">
      <div class="vx-col w-full md:w-1/3 sm:w-1/2">
        <vs-input
          class="w-full"
          label-placeholder="Charge ( % )"
          v-model="charge"
          v-validate="'required|between:1,100'"
          type="number"
          name="charge"
          @keyup.enter="addUpdateCharge()"
        />
        <span class="text-danger text-sm">{{ errors.first("charge") }}</span>
      </div>
      <div class="vx-col w-full md:w-1/3 sm:w-1/2">
        <vs-input
          class="w-full"
          label-placeholder="Fix Charge ( $ )"
          v-model="fix_charge"
          v-validate="'required|between:0,100'"
          type="number"
          name="fix charge"
          @keyup.enter="addUpdateCharge()"
        />
        <span class="text-danger text-sm">{{ errors.first("fix charge") }}</span>
      </div>
    </div>
    <!-- end add/editfamzy charge form  -->

    <div class="vx-row">
      <div class="vx-col w-full col md:w-1/3 sm:w-1/2 pt-4 text-center">
        <vs-button
          class="mr-3 mb-2 success"
          color="success"
          @click.prevent="addUpdateCharge()"
          >{{ $t("labels.Submit") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      charge: "",
      fix_charge:"",
    };
  },

  mounted() {
    this.setValidationMessage();
    this.getViewDetail();
    this.getFixChargeDetail();
  },

  methods: {
    loading() {
      this.loading(true, "#page-loading");
    },
    // get view Service provider charge form
    getViewDetail() {
      this.button_loader_success(true, "#page-loading");
      let input = {
        charge: this.value,
        code: "service_provider_percentage",
      };

      axios
        .get("admin/getCharge/service_provider_percentage", input)
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          console.log(response);
          let data = response.data.data;
          this.charge = data[0].value;
          console.log(this.charge);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
     getFixChargeDetail() {
      this.button_loader_success(true, "#page-loading");
      let input = {
        charge: this.value,
        code: "service_provider_fix_charge",
      };

      axios
        .get("admin/getCharge/service_provider_fix_charge", input)
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          console.log(response);
          let data = response.data.data;
          this.fix_charge = data[0].value;
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    // update form
    addUpdateCharge() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.button_loader_success(false, "#page-loading");
          this.saveCharge();
        }
      });
    },
    // save/add form
    saveCharge() {
      this.button_loader_success(true, "#page-loading");
      let input = {
        value_percentage: this.charge,
        value_fix:this.fix_charge,
      };
      axios
        .post("admin/setServiceProviderCharge", input)
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          let data = response.data;
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
        })
        .catch((e) => {
          this.showError(e);
        });
    },
  },

  clearInput() {
    charge = null;
  },
};
</script>